import { Box, styled } from '@mui/material';

export const StyledGradeBookBasicHeader = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '16px',
}));
